import { Tabs, styled } from '@mui/material'
import useScreenWidth from '../../../../../shared/hooks/useScreenWidth'

interface StyledTabsProps {
  value: number
  onChange: (event: React.SyntheticEvent, newValue: number) => void
  children?: React.ReactNode
}

export const TabContainer = styled((props: StyledTabsProps) => (
  <Tabs variant={useScreenWidth(700) ? 'scrollable' : 'fullWidth'} {...props} TabIndicatorProps={{ children: <span /> }} />
))(({ theme }) => ({
  root: {
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    marginTop: 24,
    marginBottom: 16,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
      marginTop: 0
    }
  },
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    height: 8,
    '& > span': {
      backgroundColor: theme.palette.primary.main,
      height: 8,
      maxWidth: 100,
      borderRadius: '8px 8px 0px 0px',
      width: '100%'
    },
    [theme.breakpoints.down('sm')]: {
      height: 4,
      '& > span': {
        height: 4,
        borderRadius: '4px 4px 0px 0px'
      }
    }
  }
}))
